export function fwcColor(token) {
  return token;
}
export function fwcBorderRadius(token) {
  return token;
}
export function fwcBorderWidth(token) {
  return token;
}